import { render } from "./shopCancellation.vue?vue&type=template&id=041a15ab&scoped=true&ts=true"
import script from "./shopCancellation.vue?vue&type=script&lang=ts"
export * from "./shopCancellation.vue?vue&type=script&lang=ts"

import "./shopCancellation.vue?vue&type=style&index=0&id=041a15ab&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041a15ab"]])

export default __exports__